import { createI18n } from 'vue-i18n'
import provideMessages from '../locales'
import pluralizationRules from '~/config/i18n'

export default defineNuxtPlugin(async ({ vueApp }) => {
    const config = useRuntimeConfig()
    const locale = config.public.locale
    const i18n = createI18n({
        legacy: false,
        globalInjection: true,
        locale,
        pluralRules: pluralizationRules().pluralizationRules,
        messages: {
            [locale]: await provideMessages(locale),
        },
    })

    // @ts-ignore
    vueApp.use(i18n)

    // exposes the instance as useNuxtApp().$i18n so code without an active component context (e.g. Pinia store
    // actions) can still translate via i18n.global.t(...), same as vue-i18n's own "outside of components" guidance
    return {
        provide: { i18n },
    }
})
